import React from 'react';
import { Container, SellerInfo, DefaultLogo, Location } from './style'

function AboutSeller({ data }) {
    const { Name, City, UF, Photo } = data

    function toTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    return (
        <Container>
            {Photo ? <img src={Photo} alt="Loja" /> : <DefaultLogo data-testid="default-logo" /> }
            <SellerInfo>
                <h2 id="VehicleSellerInformationName">{toTitleCase(Name)}</h2>
                <Location id="VehicleSellerInformationState">{`${City}, ${UF}`}</Location>
            </SellerInfo>
        </Container> 
    );
  };

  export default AboutSeller

